// @material-ui/icons components
import CategoryIcon from '@material-ui/icons/Category';
import StoreIcon from '@material-ui/icons/Store';
import LabelIcon from '@material-ui/icons/Label';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import InstagramIcon from '@material-ui/icons/Instagram';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import InfoIcon from '@material-ui/icons/Info';
// import AnalyticsIcon from '@material-ui/icons/Analytics';
// core components
import CategoryTable from "./views/admin/Category";
import Products from "./views/admin/Products";
import SubCategory from "./views/admin/SubCategory";
import Login from "./views/auth/Login";
// import AddProduct from "./views/admin/CreateProduct";
import CreateProduct from "./views/admin/createProduct/CreateProduct";
import Tags from "./views/admin/Tags";
import User from "./views/admin/User";
import Slider from "./views/admin/Slider";
import Instagram from "./views/admin/Instagram";
import Order from "./views/admin/Order";
import Reward from './views/admin/Reward';
import TransactionHistory from './views/admin/TransactionHistory';
import Subscription from './views/admin/Subscription';
import UserDetail from './views/admin/UserDetail';
import SubAdminOrder from './views/admin/SubAdminOrder';
import OrderAnalytics from './views/admin/OrderAnalytics';
import CreateOrder from './views/admin/CreateOrder';
import SubAdminInvoice from './views/admin/SubAdminIvoice';
const routes = [
  {
    path: "/index",
    name: "Products",
    icon: StoreIcon,
    iconColor: "Error",
    component: Products,
    layout: "/admin",
  },
  {
    path: "/Category",
    name: "Category",
    icon: CategoryIcon,
    iconColor: "Error",
    component: CategoryTable,
    layout: "/admin",
  },
  // {
  //   path: "/SubCategory",
  //   name: "SubCategory",
  //   icon: CategoryIcon,
  //   iconColor: "Error",
  //   component: SubCategory,
  //   layout: "/admin",
  // },
  {
    path: "/Tag",
    name: "Tags",
    icon: LabelIcon,
    iconColor: "Error",
    component: Tags,
    layout: "/admin",
  },
  {
    path: "/User",
    name: "Users",
    icon: AccountCircleIcon,
    iconColor: "Error",
    component: User,
    layout: "/admin",
  },
  {
    path: "/Slider",
    name: "Slider",
    icon: LinearScaleIcon,
    iconColor: "Error",
    component: Slider,
    layout: "/admin",
  },
  {
    path: "/Instagram",
    name: "Instagram Gallery",
    icon: InstagramIcon,
    iconColor: "Error",
    component: Instagram,
    layout: "/admin",
  },
  {
    path: "/Order",
    name: "Orders",
    icon: BookmarkBorderIcon,
    iconColor: "Error",
    component: Order,
    layout: "/admin",
  },
  {
    path: "/Reward",
    name: "Rewards",
    icon: CardGiftcardIcon,
    iconColor: "Error",
    component: Reward,
    layout: "/admin",
  },
  // {
  //   path: "/TransactionHistory",
  //   name: "Transaction History",
  //   icon: AccountBalanceWalletIcon,
  //   iconColor: "Error",
  //   component: TransactionHistory,
  //   layout: "/admin",
  // },
  {
    path: "/Subscription",
    name: "Subscription",
    icon: SubscriptionsIcon,
    iconColor: "Error",
    component: Subscription,
    layout: "/admin",
  },
  {
    path: "/UserDetail",
    name: "UserDetail",
    icon: InfoIcon,
    iconColor: "Error",
    component: UserDetail,
    layout: "/admin",
  },
  {
    path: "/login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/addProduct",
    component: CreateProduct,
    layout: "/admin",
  },
];
const routes2 = [
  {
    path: "/SubAdminOrder",
    name: "Order",
    icon: BookmarkBorderIcon,
    iconColor: "Error",
    component: SubAdminOrder,
    layout: "/admin",
  },
  {
    path: "/OrderAnalytics",
    name: "Order Analytics",
    icon: BookmarkBorderIcon,
    iconColor: "Error",
    component: OrderAnalytics,
    layout: "/admin",
  },
  {
    path: "/createOrder",
    component: CreateOrder,
    layout: "/admin",
  },
  {
    path: "/Invoice",
    name: "Invoice",
    icon: InfoIcon,
    iconColor: "Error",
    component: SubAdminInvoice,
    layout: "/admin",
  },
]
export { routes, routes2 };
